import React, { useEffect, useMemo, useState } from 'react'
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from 'reactstrap'
import { Assignment, AttachMoney, Close, Description, HowToReg, People, Work } from '@material-ui/icons'
import { IconButton } from '@mui/material'
import MaterialReactTable from 'material-react-table'
import { MRT_Localization_PT } from 'material-react-table/locales/pt'
import qs from 'qs'
import oikosApi from '../../../services/oikos'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import { notifyError, notifySuccess } from '../../../utils/notify'
import moment from 'moment'
import ModalPedidoCompra, { fetchPedidoCompraDocuments } from '../../Modals/ModalPedidoCompra/ModalPedidoCompra'
import ModalPedidoCotacao, {
  TIPO_CONTRATACAO,
  TIPO_CONTRATACAO_LABEL,
} from '../../Modals/ModalPedidoCotacao/ModalPedidoCotacao'
import {
  fetchOrcItemContratoFornId,
  fetchProjAtuacaoIdForOrcItem,
} from '../../Modals/ModalPedidoCompra/usePedidoCompraEquipeActions'
import ModalFormOrcItem from '../../Modals/ModalFormOrcItem/ModalFormOrcItem'
import ModalFormContrForn from '../../Modals/ModalFormContrForn/ModalFormContrForn'
import ModalContrFornInfo from '../../Modals/ModalContrFornInfo/ModalContrFornInfo'
import PedidosCompraListTable from './PedidosCompraListTable'
import Select from '../Input/Select'
import {
  PEDIDO_COMPRA_STATUS_APROVADO,
  PEDIDO_COMPRA_STATUS_CONTRATADO,
  mrtHeadCellProps,
  mrtTopToolbarProps,
} from './compraCotacaoTableUtils'
import { CONTR_FORN_LIST_FIELDS } from '../../../pages/MeusFornecedores/contratosTabHelpers'
import endPoints1Api from '../../../services/end_points_1'

const getOrcItemId = (orcItem) => orcItem?.orcItem_id || orcItem?.value || orcItem?.id
const getOrcItemResp = (orcItem) => orcItem?.pf_id

const BADGE_ICON_STYLE = { fontSize: 14, verticalAlign: 'text-bottom', marginLeft: 2 }

const BADGE_TONE_COLORS = {
  info: '#17a2b8',
  primary: '#007bff',
  secondary: '#6c757d',
}

const BadgeCountWithIcon = ({ count, icon: Icon, label, tone = 'secondary' }) => {
  const color = BADGE_TONE_COLORS[tone] || BADGE_TONE_COLORS.secondary
  return (
    <span className="d-inline-flex align-items-center" style={{ gap: 2, color }}>
      <span>{count}</span>
      <Icon style={{ ...BADGE_ICON_STYLE, color }} titleAccess={label} />
    </span>
  )
}

const FlatBadge = ({ title, children, style }) => (
  <div
    title={title}
    style={{
      background: 'transparent',
      padding: 0,
      lineHeight: 1.25,
      textAlign: 'center',
      ...style,
    }}
  >
    {children}
  </div>
)

const fetchOrcItemPfId = async (orcItemId) => {
  const normalizedOrcItemId = Number(orcItemId) || 0
  if (!normalizedOrcItemId) return 0

  const res = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'orcItem',
    data: { orcItem_id: normalizedOrcItemId },
  })}`)

  return Number(res?.data?.[0]?.pf_id) || 0
}

const resolveOrcItemPfId = async (orcItem) => {
  const pfIdFromRow = Number(getOrcItemResp(orcItem)) || 0
  if (pfIdFromRow) return pfIdFromRow
  return fetchOrcItemPfId(getOrcItemId(orcItem))
}

const formatContrFornParteTab = (parteTab) => {
  switch (parteTab) {
    case 'pf':
      return 'Pessoa Física'
    case 'pj':
      return 'Pessoa Jurídica'
    default:
      return parteTab || '-'
  }
}

const OrcItemsProj = ({
  orcItems,
  categGrId,
  propItemGrId,
  labelRowsPerPage = 'Despesas gerais por página',
  projId,
  orcRubrId,
  currentPfId,
  project ={},
  showEquipePedidoCompraFields = false,
  onOpenContrForn = null,
}) => {
  const [contrFornsByOrcItemId, setContrFornsByOrcItemId] = useState({})
  const [isLoadingContrForns, setIsLoadingContrForns] = useState(false)
  const [pedidosCompraByOrcItemId, setPedidosCompraByOrcItemId] = useState({})
  const [isLoadingPedidosCompra, setIsLoadingPedidosCompra] = useState(false)
  const [tableOrcItems, setTableOrcItems] = useState([])
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [pedidoCompraModalIsOpen, setPedidoCompraModalIsOpen] = useState(false)
  const [pedidoCotacaoModalIsOpen, setPedidoCotacaoModalIsOpen] = useState(false)
  const [abrirCotacaoDropdownOpen, setAbrirCotacaoDropdownOpen] = useState(false)
  const [tipoContratacaoModal, setTipoContratacaoModal] = useState(TIPO_CONTRATACAO.PADRAO)
  const [pedidoCotacaoInitialData, setPedidoCotacaoInitialData] = useState({})
  const [pedidoCotacaoUser, setPedidoCotacaoUser] = useState({ pf_id: currentPfId })
  const [cotacaoPedidoModalIsOpen, setCotacaoPedidoModalIsOpen] = useState(false)
  const [cotacaoPedidoExistenteRow, setCotacaoPedidoExistenteRow] = useState(null)
  const [compraCotacoesRefreshKey, setCompraCotacoesRefreshKey] = useState(0)
  const [pedidoCompraInitialData, setPedidoCompraInitialData] = useState({})
  const [editPedidoCompraRow, setEditPedidoCompraRow] = useState(null)
  const [viewPedidoCompraModalIsOpen, setViewPedidoCompraModalIsOpen] = useState(false)
  const [viewPedidoCompraRow, setViewPedidoCompraRow] = useState(null)
  const [viewCompraCotacaoModalIsOpen, setViewCompraCotacaoModalIsOpen] = useState(false)
  const [viewCompraCotacaoRow, setViewCompraCotacaoRow] = useState(null)
  const [pedidosCompraListModalIsOpen, setPedidosCompraListModalIsOpen] = useState(false)
  const [selectedOrcItemPedidosCompra, setSelectedOrcItemPedidosCompra] = useState(null)
  const [vagasActionsDropdownOrcItemId, setVagasActionsDropdownOrcItemId] = useState(null)
  const [showAlocarSelectOrcItemId, setShowAlocarSelectOrcItemId] = useState(null)
  const [cotacoesActionsDropdownOrcItemId, setCotacoesActionsDropdownOrcItemId] = useState(null)
  const [showAbrirCotacaoTiposOrcItemId, setShowAbrirCotacaoTiposOrcItemId] = useState(null)
  const [selContratosInternos, setSelContratosInternos] = useState([])
  const [isLoadingContratosInternos, setIsLoadingContratosInternos] = useState(false)
  const [isSavingAlocacaoOrcItemId, setIsSavingAlocacaoOrcItemId] = useState(null)
  const [linkedContratoForn, setLinkedContratoForn] = useState(null)
  const [isLoadingLinkedContratoForn, setIsLoadingLinkedContratoForn] = useState(false)
  useEffect(() => {
    if (!Array.isArray(orcItems)) {
      setTableOrcItems([])
      return
    }

    setTableOrcItems(orcItems)
  }, [orcItems])

  const normalizedOrcItems = useMemo(() => {
    if (!Array.isArray(tableOrcItems)) return []
    return tableOrcItems
  }, [tableOrcItems])

  const filteredOrcItems = useMemo(() => normalizedOrcItems.filter(
    (orcItem) => {
      if (Number(orcItem.orcItem_ativo) !== 1) return false

      const hasPropOrcItem = Number(orcItem.propOrcItem_id) > 0

      // Com propOrcItem: filtra por propItemGr_id; sem vínculo, mantém categGr_id.
      if (propItemGrId != null && propItemGrId !== '') {
        if (hasPropOrcItem) {
          return Number(orcItem.propItemGr_id) === Number(propItemGrId)
        }
        return Number(orcItem.categGr_id) === Number(categGrId)
      }

      return Number(orcItem.categGr_id) === Number(categGrId)
    },
  ), [normalizedOrcItems, categGrId, propItemGrId])

  const orcItemIds = useMemo(() => [...new Set(
    filteredOrcItems
      .map(getOrcItemId)
      .filter(Boolean),
  )], [filteredOrcItems])

  const normalizeListagemRow = (row) => {
    if (!showEquipePedidoCompraFields) return row

    // Itens orçamentários de Equipe costumam ficar inativos assim que uma vaga é aberta,
    // o que faz a view viewRubr_OrcItem não retornar o item mais. Como já temos a hierarquia
    // (centro de custo, orçamento do projeto) carregada aqui, repassamos junto com a linha
    // para que o modal de contratação não dependa exclusivamente daquela view.
    const orcItemVinculado = normalizedOrcItems.find(
      (orcItem) => Number(getOrcItemId(orcItem)) === Number(row.orcItem_id),
    )

    return {
      ...row,
      pedidoCompra_desc: row.pedidoCompra_desc || row.vaga_descricao || row.vaga_nome || '',
      pedidoCompra_vlrLimite: row.pedidoCompra_vlrLimite ?? row.vaga_salarioMaximo ?? 0,
      pedidoCompra_dtVigIni: row.pedidoCompra_dtVigIni || row.vaga_dtVigIni || null,
      pedidoCompra_dtVigFim: row.pedidoCompra_dtVigFim || row.vaga_dtVigFim || null,
      pedidoCompraStatus_nome: row.vagaStatus_nome || row.pedidoCompraStatus_nome || '-',
      // Não usamos mais pedidoCompraTp_id para marcar "vaga": quem define isso é o
      // categGr_id do orcItem vinculado (categGr_id = 2 = Equipe).
      categGr_id: row.categGr_id ?? orcItemVinculado?.categGr_id ?? null,
      vaga_inhireId: row.vaga_inhireId || null,
      centroDeCustoRubr_id: row.centroDeCustoRubr_id || orcItemVinculado?.nivel2_id || null,
      orcRubr_id: row.orcRubr_id || orcRubrId || null,
      orcItem_label: row.orcItem_label || orcItemVinculado?.orcItem_desc || null,
    }
  }

  const groupListagemByOrcItemId = (rows = []) => (
    rows.reduce((acc, row) => {
      const normalizedRow = normalizeListagemRow(row)
      const orcItemId = String(normalizedRow.orcItem_id)
      if (!orcItemId) return acc
      acc[orcItemId] = [...(acc[orcItemId] || []), normalizedRow]
      return acc
    }, {})
  )

  const fetchPedidosCompraOuVagaByOrcItemIds = async (ids = []) => {
    if (ids.length <= 0) {
      setPedidosCompraByOrcItemId({})
      setIsLoadingPedidosCompra(false)
      return
    }

    try {
      setIsLoadingPedidosCompra(true)

      let rows = []

      if (showEquipePedidoCompraFields) {
        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'vaga',
          data: {
            orcItem_id: `!IN!(${ids.join(',')})`,
          },
          fields: {
            '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = vaga.orcItem_id LIMIT 1) LIMIT 1)': 'pf_nomeExibicao',
            '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1) LIMIT 1) LIMIT 1)': 'pf_emailProf',
            '(SELECT vagaStatus_nome FROM vagaStatus WHERE vagaStatus.vagaStatus_id = vaga.vagaStatus_id LIMIT 1)': 'vagaStatus_nome',
            '(SELECT pedidoCompra_dtSolicitacao FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1)': 'pedidoCompra_dtSolicitacao',
            '(SELECT pedidoCompraStatus_id FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1)': 'pedidoCompraStatus_id',
            '(SELECT pedidoCompraStatus_nome FROM pedidoCompraStatus WHERE pedidoCompraStatus.pedidoCompraStatus_id = (SELECT pedidoCompraStatus_id FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = vaga.pedidoCompra_id LIMIT 1) LIMIT 1)': 'pedidoCompraStatus_nome',
            '(SELECT COUNT(*) FROM candidato WHERE candidato.vaga_id = vaga.vaga_id AND candidato.compraCotacao_id IS NOT NULL AND candidato.compraCotacao_id > 0)': 'compraCotacao_count',
            vaga_inhireId: 'vaga_inhireId',
            vaga_documentosObrigatorios: 'vaga_documentosObrigatorios',
            vaga_beneficios: 'vaga_beneficios',
          },
        })}`)
        rows = (res.data || []).filter((row) => Number(row.pedidoCompra_id) > 0)
      } else {
        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'pedidoCompra',
          data: {
            orcItem_id: `!IN!(${ids.join(',')})`,
            pedidoCompra_ativo: 1,
          },
          fields: {
            '(SELECT compraStatus_nome FROM compraStatus WHERE pedidoCompra.compraStatus_id = compraStatus.compraStatus_id LIMIT 1)': 'compraStatus_nome',
            //'(SELECT pf_nomeExibicao FROM pf WHERE pedidoCompra.pf_id = pf.pf_id LIMIT 1)': 'pf_nomeExibicao',
            '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = pedidoCompra.orcItem_id LIMIT 1) LIMIT 1)': 'pf_emailProf',
            '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = pedidoCompra.orcItem_id LIMIT 1) LIMIT 1)': 'pf_nomeExibicao',
            '(SELECT pedidoCompraStatus_nome FROM pedidoCompraStatus WHERE pedidoCompra.pedidoCompraStatus_id = pedidoCompraStatus.pedidoCompraStatus_id LIMIT 1)': 'pedidoCompraStatus_nome',
            '(SELECT COUNT(*) FROM compraCotacao WHERE compraCotacao.pedidoCompra_id = pedidoCompra.pedidoCompra_id)': 'compraCotacao_count',
            pedidoCompra_comContrato: 'pedidoCompra_comContrato',
          },
        })}`)
        rows = res.data || []
      }

      console.log('rows', rows)

      setPedidosCompraByOrcItemId(groupListagemByOrcItemId(rows))
      setIsLoadingPedidosCompra(false)
    } catch (e) {
      setPedidosCompraByOrcItemId({})
      setIsLoadingPedidosCompra(false)
      notifyError('Erro ao carregar pedidos de compra dos itens orcamentarios.')
      console.log('Erro ao carregar pedidosCompra/vaga por orcItem:', e)
    }
  }

  const handleOpenModal = () => {
    setModalIsOpen(true)
  }

  const createLinkedTasks = async ({ taskTabRef, taskTabId, taskDesc, taskOrientacao, orcItemId, taskTp_id, pfId }) => {
    const normalizedTaskTabId = Number(taskTabId) || 0
    if (!taskTabRef || !normalizedTaskTabId) return

    const selectedOrcItem = normalizedOrcItems.find(item => Number(getOrcItemId(item)) === Number(orcItemId))
    
    const centroDeCusto = Number(selectedOrcItem?.nivel2_id)

    const postBodyTask = {
      action: 'insert',
      table: 'task',
      data: {
        task_tabRef: taskTabRef,
        task_tabId: normalizedTaskTabId,
        pf_id: currentPfId || undefined,
        task_prazo: moment().add(3, 'days').format('YYYY-MM-DD') || undefined,
        taskTp_id: taskTp_id,
        dpto_id: undefined,
        task_desc: taskDesc,
        task_orientacao: taskOrientacao,
      },
    }

    const responseTask = await oikosApi.post('/', postBodyTask)
    const taskMaeId = responseTask?.data?.[0]?.task_id

    if (!taskMaeId) {
      notifyError('Sem tarefa mãe')
      return
    }
    
    const normalizedPfId = Number(pfId) || 0
    const pfDestino = normalizedPfId > 0
      ? normalizedPfId
      : ([13, 14].includes(centroDeCusto) ? 2 : 1)

    await oikosApi.post('/', {
      ...postBodyTask,
      data: {
        ...postBodyTask.data,
        pf_id: pfDestino,
        task_mae: taskMaeId,
      },
    })
  }

  const refreshOrcItems = async () => {
    if (!projId) return

    try {
      const res = await endPoints1Api.post('/',
        {
          acao: 'get_orcItems_proj',
          proj_id: projId,
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        })

      setTableOrcItems(Array.isArray(res.data) ? res.data : [])
    } catch (e) {
      notifyError('Erro ao atualizar itens orcamentarios.')
      console.log('Erro ao atualizar orcItems do projeto:', e)
    }
  }

  const fetchPedidosCompraByIds = fetchPedidosCompraOuVagaByOrcItemIds

  const handleOpenViewPedidoCompraModal = async (pedidoCompra) => {
    setViewPedidoCompraRow(pedidoCompra);
    setViewPedidoCompraModalIsOpen(true);
  };

  const handleOpenViewCompraCotacaoModal = (compraCotacao, pedidoCompra) => {
    const compraCotacaoId = Number(compraCotacao?.compraCotacao_id) || 0
    if (!compraCotacaoId) return

    setViewCompraCotacaoRow({
      ...compraCotacao,
      pedidoCompra_id: compraCotacao.pedidoCompra_id || pedidoCompra?.pedidoCompra_id,
    })
    setViewCompraCotacaoModalIsOpen(true)
  }

  const handleOpenEditPedidoCompraModal = (listagemRow) => {
    if (!Number(listagemRow?.pedidoCompra_id)) return
    setEditPedidoCompraRow(listagemRow)
    setPedidoCompraInitialData({})
    setPedidoCompraModalIsOpen(true)
  };

  const handleClosePedidoCompraModal = () => {
    setPedidoCompraModalIsOpen(false)
    setPedidoCompraInitialData({})
    setEditPedidoCompraRow(null)
  }

  const handleOpenCotacaoParaPedidoExistente = (pedidoCompra) => {
    if (!Number(pedidoCompra?.pedidoCompra_id)) return
    setCotacaoPedidoExistenteRow(pedidoCompra)
    setCotacaoPedidoModalIsOpen(true)
  }

  const handleCloseCotacaoPedidoModal = () => {
    setCotacaoPedidoModalIsOpen(false)
    setCotacaoPedidoExistenteRow(null)
  }

  const fetchContratoFornVinculado = async (contratoFornId) => {
    const normalizedContratoFornId = Number(contratoFornId) || 0
    if (!normalizedContratoFornId) return null

    try {
      setIsLoadingLinkedContratoForn(true)
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contratoForn',
        data: {
          contratoForn_id: normalizedContratoFornId,
        },
        fields: {
          "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = contratoForn.contratoForn_parteId AND contratoForn.contratoForn_parteTab = 'pf' LIMIT 1)": 'contratoForn_parteNomePf',
          "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = contratoForn.contratoForn_parteId AND contratoForn.contratoForn_parteTab = 'pj' LIMIT 1)": 'contratoForn_parteNomePj',
        },
      })}`)

      const contratoForn = res?.data?.[0] || null
      setLinkedContratoForn(contratoForn)
      return contratoForn
    } catch (e) {
      setLinkedContratoForn(null)
      notifyError('Erro ao carregar contrato interno vinculado a vaga.')
      console.log('Erro ao carregar contratoForn vinculado ao orcItem:', e)
      return null
    } finally {
      setIsLoadingLinkedContratoForn(false)
    }
  }

  const updateOrcItemContratoFornInState = (orcItemId, contratoFornId) => {
    if (!orcItemId || !contratoFornId) return

    setTableOrcItems((prev) => prev.map((item) => (
      Number(getOrcItemId(item)) === Number(orcItemId)
        ? { ...item, contratoForn_id: contratoFornId }
        : item
    )))

    setSelectedOrcItemPedidosCompra((prev) => (
      prev && Number(getOrcItemId(prev)) === Number(orcItemId)
        ? { ...prev, contratoForn_id: contratoFornId }
        : prev
    ))
  }

  const prepareOrcItemPedidoContext = async (orcItemId, orcItemResp, orcItem) => {
    const pfId = Number(orcItemResp) || await resolveOrcItemPfId(orcItem)
    if (!pfId) {
      notifyError('Esse item orçamentário deve possuir um responsável')
      return null
    }

    const freshOrcItem = filteredOrcItems.find(
      (item) => Number(getOrcItemId(item)) === Number(orcItemId),
    )
    let contratoFornId = Number(freshOrcItem?.contratoForn_id) || Number(orcItem?.contratoForn_id) || 0

    if (!contratoFornId && orcItemId) {
      contratoFornId = await fetchOrcItemContratoFornId(orcItemId)
      if (contratoFornId) {
        updateOrcItemContratoFornInState(orcItemId, contratoFornId)
      }
    }

    let projAtuacaoId = Number(freshOrcItem?.projAtuacao_id) || Number(orcItem?.projAtuacao_id) || 0
    if (!projAtuacaoId && orcItemId) {
      projAtuacaoId = await fetchProjAtuacaoIdForOrcItem(orcItemId)
    }

    return {
      pfId,
      orcItemId,
      freshOrcItem,
      contratoFornId,
      projAtuacaoId,
    }
  }

  const handleOpenPedidoCompraModal = async (orcItemId, orcItemResp, orcItem) => {
    const context = await prepareOrcItemPedidoContext(orcItemId, orcItemResp, orcItem)
    if (!context) return

    const { pfId, orcItemId: resolvedOrcItemId, contratoFornId, projAtuacaoId } = context

    setEditPedidoCompraRow(null)
    setPedidoCompraInitialData({
      orcItem_id: resolvedOrcItemId,
      pf_id: pfId,
      ...(projAtuacaoId ? { projAtuacao_id: projAtuacaoId } : {}),
      ...(contratoFornId ? {
        contratoForn_id: contratoFornId,
        contratoForn_idLocked: true,
      } : {}),
    })
    setPedidoCompraModalIsOpen(true)
  }

  const handleOpenNovoPedidoCotacao = async (tipo, orcItemId, orcItemResp, orcItem) => {
    setAbrirCotacaoDropdownOpen(false)
    const context = await prepareOrcItemPedidoContext(orcItemId, orcItemResp, orcItem)
    if (!context) return

    const { pfId, orcItemId: resolvedOrcItemId, freshOrcItem, projAtuacaoId } = context

    setEditPedidoCompraRow(null)
    setTipoContratacaoModal(tipo)
    setPedidoCotacaoInitialData({
      orcItem_id: resolvedOrcItemId,
      pf_id: pfId,
      centroDeCustoRubr_id: freshOrcItem?.nivel2_id || orcItem?.nivel2_id || null,
      ...(projAtuacaoId ? { projAtuacao_id: projAtuacaoId } : {}),
    })
    setPedidoCotacaoUser({ pf_id: pfId })
    setPedidoCotacaoModalIsOpen(true)
  }

  const handleClosePedidoCotacaoModal = () => {
    setPedidoCotacaoModalIsOpen(false)
    setPedidoCotacaoInitialData({})
    setPedidoCotacaoUser({ pf_id: currentPfId })
  }

  const handleOpenPedidosCompraListModal = async (orcItem) => {
    const pfId = await resolveOrcItemPfId(orcItem)
    if (!pfId) {
      notifyError('Esse item orçamentário deve possuir um responsável')
      return
    }

    const orcItemId = getOrcItemId(orcItem)
    let contratoFornId = Number(orcItem?.contratoForn_id) || 0
    if (!contratoFornId && orcItemId) {
      contratoFornId = await fetchOrcItemContratoFornId(orcItemId)
      if (contratoFornId) {
        updateOrcItemContratoFornInState(orcItemId, contratoFornId)
      }
    }

    setLinkedContratoForn(null)
    setSelectedOrcItemPedidosCompra({
      ...orcItem,
      pf_id: pfId,
      ...(contratoFornId ? { contratoForn_id: contratoFornId } : {}),
    })
    setPedidosCompraListModalIsOpen(true)

    if (showEquipePedidoCompraFields && contratoFornId) {
      await fetchContratoFornVinculado(contratoFornId)
    }
  }

  const handleClosePedidosCompraListModal = () => {
    setPedidosCompraListModalIsOpen(false)
    setSelectedOrcItemPedidosCompra(null)
    setLinkedContratoForn(null)
    setIsLoadingLinkedContratoForn(false)
  }

  const ensureContratosInternosLoaded = async () => {
    if (selContratosInternos.length > 0 || isLoadingContratosInternos) return
    try {
      setIsLoadingContratosInternos(true)
      const res = await fetch('https://oikos.ecoss.is/oikos/planilha.listload.php?lista=contratoForn')
      const data = await res.json()
      setSelContratosInternos(Array.isArray(data) ? data : [])
    } catch (e) {
      setSelContratosInternos([])
      notifyError('Erro ao carregar contratos internos.')
      console.log('Erro ao carregar contratos internos:', e)
    } finally {
      setIsLoadingContratosInternos(false)
    }
  }

  const handleToggleVagasActionsDropdown = async (orcItemId, event) => {
    // Clique no react-select (portal no body) não deve fechar o dropdown de Vagas.
    if (event?.target?.closest?.('[class*="select2-selection"]')) {
      return
    }

    const normalizedId = String(orcItemId || '')
    const isCurrentlyOpen = vagasActionsDropdownOrcItemId === normalizedId

    if (isCurrentlyOpen) {
      // Fecha só o menu. Não limpa o select de alocação (ele vive fora do dropdown).
      setVagasActionsDropdownOrcItemId(null)
      return
    }

    // Abrir o menu de ações: esconde select inline anterior desta (ou outra) linha.
    setVagasActionsDropdownOrcItemId(normalizedId)
    setShowAlocarSelectOrcItemId(null)
    await ensureContratosInternosLoaded()
  }

  const handleShowAlocarInternoSelect = async (orcItemId) => {
    const normalizedId = String(orcItemId || '')
    setVagasActionsDropdownOrcItemId(null)
    setShowAlocarSelectOrcItemId(normalizedId)
    await ensureContratosInternosLoaded()
  }

  const handleAlocarInternoSelect = async (orcItem, option) => {
    const orcItemId = Number(getOrcItemId(orcItem)) || 0
    const contratoFornId = Number(option?.value) || 0
    if (!orcItemId || !contratoFornId) return

    try {
      setIsSavingAlocacaoOrcItemId(String(orcItemId))
      await oikosApi.post('/', {
        action: 'update',
        table: 'orcItem',
        data: {
          orcItem_id: orcItemId,
          contratoForn_id: contratoFornId,
        },
      })
      updateOrcItemContratoFornInState(orcItemId, contratoFornId)
      notifySuccess('Alocação interna salva com sucesso.')
      setVagasActionsDropdownOrcItemId(null)
      setShowAlocarSelectOrcItemId(null)
      await refreshOrcItems()
    } catch (e) {
      notifyError('Erro ao salvar alocação interna.')
      console.log('Erro ao vincular contratoForn ao orcItem:', e)
    } finally {
      setIsSavingAlocacaoOrcItemId(null)
    }
  }

  const handleAbrirVagaFromActions = async (orcItem) => {
    setVagasActionsDropdownOrcItemId(null)
    setShowAlocarSelectOrcItemId(null)
    const orcItemId = getOrcItemId(orcItem)
    await handleOpenPedidoCompraModal(orcItemId, getOrcItemResp(orcItem), orcItem)
  }

  const handleVerVagasFromActions = async (orcItem) => {
    setVagasActionsDropdownOrcItemId(null)
    setShowAlocarSelectOrcItemId(null)
    await handleOpenPedidosCompraListModal(orcItem)
  }

  const handleToggleCotacoesActionsDropdown = (orcItemId) => {
    const normalizedId = String(orcItemId || '')
    const isCurrentlyOpen = cotacoesActionsDropdownOrcItemId === normalizedId

    if (isCurrentlyOpen) {
      setCotacoesActionsDropdownOrcItemId(null)
      setShowAbrirCotacaoTiposOrcItemId(null)
      return
    }

    setCotacoesActionsDropdownOrcItemId(normalizedId)
    setShowAbrirCotacaoTiposOrcItemId(null)
  }

  const handleToggleAbrirCotacaoTipos = (orcItemId) => {
    const normalizedId = String(orcItemId || '')
    setShowAbrirCotacaoTiposOrcItemId((prev) => (
      prev === normalizedId ? null : normalizedId
    ))
  }

  const handleAbrirCotacaoTipoFromActions = async (orcItem, tipo) => {
    setCotacoesActionsDropdownOrcItemId(null)
    setShowAbrirCotacaoTiposOrcItemId(null)
    const orcItemId = getOrcItemId(orcItem)
    await handleOpenNovoPedidoCotacao(tipo, orcItemId, getOrcItemResp(orcItem), orcItem)
  }

  const handleVerCotacoesFromActions = async (orcItem) => {
    setCotacoesActionsDropdownOrcItemId(null)
    setShowAbrirCotacaoTiposOrcItemId(null)
    await handleOpenPedidosCompraListModal(orcItem)
  }

  const handleOpenContrFornFromList = (contrFornId, options = {}) => {
    if (!contrFornId || typeof onOpenContrForn !== 'function') return
    handleClosePedidosCompraListModal()
    onOpenContrForn(contrFornId, options)
  }

  useEffect(() => {
    let isMounted = true

    async function fetchContrFornsByOrcItems() {
      if (orcItemIds.length <= 0) {
        setContrFornsByOrcItemId({})
        setIsLoadingContrForns(false)
        return
      }

      try {
        setIsLoadingContrForns(true)

        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrForn',
          data: {
            orcItem_id: `!IN!(${orcItemIds.join(',')})`,
            contrForn_ativo: 1,
          },
          fields: CONTR_FORN_LIST_FIELDS,
        })}`)

        if (!isMounted) return

        const nextContrFornsByOrcItemId = (res.data || []).reduce((acc, contrForn) => {
          const orcItemId = String(contrForn.orcItem_id)
          acc[orcItemId] = [...(acc[orcItemId] || []), contrForn]
          return acc
        }, {})

        setContrFornsByOrcItemId(nextContrFornsByOrcItemId)
        setIsLoadingContrForns(false)
      } catch (e) {
        if (!isMounted) return
        setContrFornsByOrcItemId({})
        setIsLoadingContrForns(false)
        notifyError('Erro ao carregar contratos dos itens orçamentários.')
        console.log('Erro ao carregar contrForns por orcItem:', e)
      }
    }

    fetchContrFornsByOrcItems()

    return () => {
      isMounted = false
    }
  }, [orcItemIds])

  useEffect(() => {
    fetchPedidosCompraOuVagaByOrcItemIds(orcItemIds)
  }, [orcItemIds, showEquipePedidoCompraFields])

  const columns = useMemo(() => [
    {
      accessorKey: 'orcItem_desc',
      header: 'Item Orc.',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.orcItem_desc && row.unidade_label) {
          return row.orcItem_desc + " (" + row.unidade_label + ")"
        }
        if (row.orcItem_desc) {
          return row.orcItem_desc
        }
        return 'Sem descrição'
      },
    },
    {
      accessorKey: 'propOrcItem_qtd',
      header: 'Quantidade total',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_qtd) {
          return row.propOrcItem_qtd
        }
        return 'Sem quantidade'
      },
    },
    {
      header: 'Valor unitário',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_valor) {
          return currencyFormatter.format(row.propOrcItem_valor)
        }
        return 'Sem valor'
      },
    },
    {
      header: 'Valor total',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_valor) {
          return currencyFormatter.format(row.propOrcItem_valor * row.propOrcItem_qtd)
        }
        return 'Sem valor'
      },
    },
    {
      id: 'pedidoCompraActions',
      header: "Ações",
      size: 220,
      muiTableBodyCellProps: {
        sx: {
          overflow: 'visible',
          maxWidth: 'none',
          whiteSpace: 'normal',
        },
      },
      Cell: ({ row }) => {
        const orcItemId = String(getOrcItemId(row.original) || '')
        const pedidosDoOrcItem = pedidosCompraByOrcItemId[orcItemId] || []
        const pedidosCount = pedidosDoOrcItem.length
        const emSelecaoCount = pedidosDoOrcItem.filter(
          (pedido) => Number(pedido.pedidoCompraStatus_id) === PEDIDO_COMPRA_STATUS_APROVADO,
        ).length
        const contratadosCount = pedidosDoOrcItem.filter(
          (pedido) => Number(pedido.pedidoCompraStatus_id) === PEDIDO_COMPRA_STATUS_CONTRATADO,
        ).length
        const propostasCount = pedidosDoOrcItem.reduce(
          (sum, pedido) => sum + (Number(pedido.compraCotacao_count) || 0),
          0,
        )
        const mainSingular = showEquipePedidoCompraFields ? 'vaga' : 'cotação'
        const mainPlural = showEquipePedidoCompraFields ? 'vagas' : 'cotações'
        const mainLabel = pedidosCount === 1 ? mainSingular : mainPlural
        const contratadoSingular = 'contratada'
        const contratadoPlural = 'contratadas'
        const contratadoLabel = contratadosCount === 1 ? contratadoSingular : contratadoPlural
        const secondaryStatusLine = `${emSelecaoCount} em seleção · ${contratadosCount} ${contratadoLabel}`
        const propostasLabel = showEquipePedidoCompraFields
          ? (propostasCount === 1 ? 'candidato' : 'candidatos')
          : (propostasCount === 1 ? 'proposta' : 'propostas')
        const MainIcon = showEquipePedidoCompraFields ? Work : Assignment
        const PropostasIcon = showEquipePedidoCompraFields ? People : Description

        return (
          <div className="d-flex flex-column align-items-center flex-wrap" style={{ gap: '6px' }}>
            {showEquipePedidoCompraFields ? (
              <div className="d-flex flex-column align-items-center" style={{ gap: 6, width: '100%' }}>
                <ButtonDropdown
                  isOpen={vagasActionsDropdownOrcItemId === orcItemId}
                  toggle={(event) => handleToggleVagasActionsDropdown(orcItemId, event)}
                >
                  <DropdownToggle caret size="sm" color="link" className="px-0">
                    Vagas
                  </DropdownToggle>
                  <DropdownMenu right style={{ minWidth: 200 }}>
                    <DropdownItem
                      toggle={false}
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        handleShowAlocarInternoSelect(orcItemId)
                      }}
                    >
                      Alocar interno
                    </DropdownItem>
                    <DropdownItem
                      disabled={Number(row.original.contratoForn_id) > 0}
                      title={Number(row.original.contratoForn_id) > 0
                        ? 'Esta vaga já está preenchida por um contrato interno vinculado ao item orçamentário.'
                        : undefined}
                      onClick={() => handleAbrirVagaFromActions(row.original)}
                    >
                      Abrir vaga
                    </DropdownItem>
                    <DropdownItem onClick={() => handleVerVagasFromActions(row.original)}>
                      Ver vagas
                    </DropdownItem>
                  </DropdownMenu>
                </ButtonDropdown>
                {showAlocarSelectOrcItemId === orcItemId && (
                  <div
                    className="d-flex align-items-center"
                    style={{ minWidth: 220, width: '100%', maxWidth: 280, zIndex: 5, gap: 4 }}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {isSavingAlocacaoOrcItemId === orcItemId ? (
                        <span className="text-muted d-inline-flex align-items-center">
                          <Spinner size="sm" className="mr-2" />
                          Salvando...
                        </span>
                      ) : isLoadingContratosInternos ? (
                        <span className="text-muted d-inline-flex align-items-center">
                          <Spinner size="sm" className="mr-2" />
                          Carregando...
                        </span>
                      ) : (
                        <Select
                          classNamePrefix="select2-selection"
                          placeholder="Selecione um contrato interno"
                          options={selContratosInternos}
                          value={selContratosInternos.find(
                            (option) => String(option.value) === String(row.original.contratoForn_id),
                          ) || null}
                          onChange={(option) => handleAlocarInternoSelect(row.original, option)}
                          isDisabled={Boolean(isSavingAlocacaoOrcItemId)}
                          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                          menuShouldScrollIntoView={false}
                          menuPlacement="auto"
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      )}
                    </div>
                    <IconButton
                      size="small"
                      title="Fechar"
                      aria-label="Fechar alocação interna"
                      disabled={isSavingAlocacaoOrcItemId === orcItemId}
                      onClick={() => setShowAlocarSelectOrcItemId(null)}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </div>
                )}
              </div>
            ) : (
              <ButtonDropdown
                isOpen={cotacoesActionsDropdownOrcItemId === orcItemId}
                toggle={() => handleToggleCotacoesActionsDropdown(orcItemId)}
              >
                <DropdownToggle caret size="sm" color="link" className="px-0">
                  Cotações
                </DropdownToggle>
                <DropdownMenu right style={{ minWidth: 220 }}>
                  <DropdownItem
                    toggle={false}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handleToggleAbrirCotacaoTipos(orcItemId)
                    }}
                  >
                    Abrir cotação
                  </DropdownItem>
                  {showAbrirCotacaoTiposOrcItemId === orcItemId && (
                    <>
                      <DropdownItem
                        onClick={() => handleAbrirCotacaoTipoFromActions(
                          row.original,
                          TIPO_CONTRATACAO.PADRAO,
                        )}
                      >
                        {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.PADRAO]}
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleAbrirCotacaoTipoFromActions(
                          row.original,
                          TIPO_CONTRATACAO.RAPIDA,
                        )}
                      >
                        {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.RAPIDA]}
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleAbrirCotacaoTipoFromActions(
                          row.original,
                          TIPO_CONTRATACAO.ADESAO,
                        )}
                      >
                        {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.ADESAO]}
                      </DropdownItem>
                    </>
                  )}
                  <DropdownItem onClick={() => handleVerCotacoesFromActions(row.original)}>
                    Ver cotações
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            )}
            {isLoadingPedidosCompra ? (
              <Spinner size="sm" />
            ) : (
              <>
                <FlatBadge
                  title={`${pedidosCount} ${mainLabel}${pedidosCount > 0 ? ` — ${secondaryStatusLine}` : ''}`}
                  style={pedidosCount > 0 ? { whiteSpace: 'normal' } : undefined}
                >
                  <div>
                    <BadgeCountWithIcon
                      count={pedidosCount}
                      icon={MainIcon}
                      label={mainLabel}
                      tone={pedidosCount > 0 ? 'info' : 'secondary'}
                    />
                  </div>
                  {pedidosCount > 0 && (
                    <div
                      className="d-inline-flex align-items-center justify-content-center"
                      style={{ fontSize: '0.75em', fontWeight: 400, gap: 4 }}
                    >
                      <BadgeCountWithIcon
                        count={emSelecaoCount}
                        icon={HowToReg}
                        label="em seleção"
                        tone={emSelecaoCount > 0 ? 'info' : 'secondary'}
                      />
                      <span style={{ color: BADGE_TONE_COLORS.secondary }}>·</span>
                      <BadgeCountWithIcon
                        count={contratadosCount}
                        icon={AttachMoney}
                        label={contratadoLabel}
                        tone={contratadosCount > 0 ? 'info' : 'secondary'}
                      />
                    </div>
                  )}
                </FlatBadge>
                <FlatBadge title={`${propostasCount} ${propostasLabel}`}>
                  <BadgeCountWithIcon
                    count={propostasCount}
                    icon={PropostasIcon}
                    label={propostasLabel}
                    tone={propostasCount > 0 ? 'primary' : 'secondary'}
                  />
                </FlatBadge>
              </>
            )}
          </div>
        )
      },
    },
  ], [
    showEquipePedidoCompraFields,
    pedidosCompraByOrcItemId,
    isLoadingPedidosCompra,
    vagasActionsDropdownOrcItemId,
    showAlocarSelectOrcItemId,
    cotacoesActionsDropdownOrcItemId,
    showAbrirCotacaoTiposOrcItemId,
    selContratosInternos,
    isLoadingContratosInternos,
    isSavingAlocacaoOrcItemId,
  ])

  const renderDetailPanel = ({ row }) => {
    const orcItemId = getOrcItemId(row.original)
    const contrForns = contrFornsByOrcItemId[String(orcItemId)] || []

    if (isLoadingContrForns) {
      return (
        <div className="p-3 d-flex align-items-center">
          <Spinner size="sm" className="mr-2" />
          <span className="text-muted">Carregando contratos...</span>
        </div>
      )
    }

    if (contrForns.length <= 0) {
      return (
        <div className="p-3">
          <span className="text-muted">Nenhum contrato localizado para este item orçamentário.</span>
        </div>
      )
    }

    const detailColumns = [
      {
        accessorKey: 'contrForn_num',
        header: 'Número',
        size: 100,
        maxWidth: 200,
      },
      {
        accessorKey: 'contrForn_desc',
        header: 'Descrição',
        size: 100,
      },
      {
        id: 'nomeFornecedor',
        header: 'Nome Fornecedor',
        accessorFn: (row) => row.contratado_nomePj || row.contratado_nomePf || '',
        size: 100,
        Cell: ({ cell }) => {
          const value = cell.getValue() || ''
          return (
            <span title={value} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {value || '-'}
            </span>
          )
        },
      },
      {
        accessorKey: 'contrForn_vlrGlobal',
        header: 'Valor',
        accessorFn: (row) => {
          if (row.contrForn_vlrGlobal) {
            return parseFloat(row.contrForn_vlrGlobal).toFixed(2)
          }
          return '0.00'
        },
        Cell: ({ cell }) => {
          const value = cell.getValue()
          return value ? `R$ ${parseFloat(value).toFixed(2).replace('.', ',')}` : 'R$ 0,00'
        },
        size: 100,
      },
      {
        accessorKey: 'contrForn_dtAssin',
        header: 'Data Assinatura',
        accessorFn: (row) => {
          if (row.contrForn_dtAssin) {
            return moment(row.contrForn_dtAssin, 'YYYY-MM-DD').toDate()
          }
          return null
        },
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row: contrFornRow }) => {
          if (contrFornRow.original.contrForn_dtAssin) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
          return null
        },
      },
      {
        accessorKey: 'contrForn_dtVigIni',
        header: 'Início Vigência',
        accessorFn: (row) => {
          if (row.contrForn_dtVigIni) {
            return moment(row.contrForn_dtVigIni, 'YYYY-MM-DD').toDate()
          }
          return null
        },
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row: contrFornRow }) => {
          if (contrFornRow.original.contrForn_dtVigIni) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
          return null
        },
      },
      {
        accessorKey: 'contrForn_dtVigFim',
        header: 'Fim Vigência',
        accessorFn: (row) => {
          if (row.contrForn_dtVigFim) {
            return moment(row.contrForn_dtVigFim, 'YYYY-MM-DD').toDate()
          }
          return null
        },
        size: 100,
        sortingFn: 'datetime',
        Cell: ({ cell, row: contrFornRow }) => {
          if (contrFornRow.original.contrForn_dtVigFim) {
            return moment(cell.getValue()).format('DD/MM/YYYY')
          }
          return null
        },
      },
      {
        accessorKey: 'orcItem_desc',
        header: 'Item Orçamentário',
        accessorFn: (row) => row.orcItem_desc || null,
        size: 100,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row: contrFornRow }) => {
          if (contrFornRow.original.orcItem_desc) {
            return cell.getValue()
          }
          return null
        },
      },
      {
        accessorKey: 'contrFornStatus_nome',
        header: 'Status',
        accessorFn: (row) => row.contrFornStatus_nome || null,
        size: 100,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row: contrFornRow }) => {
          if (contrFornRow.original.contrFornStatus_nome) {
            return cell.getValue()
          }
          return null
        },
      },
      {
        accessorKey: 'contrFornTp_nome',
        header: 'Tipo',
        accessorFn: (row) => {
          if (row.contrFornTp_id) {
            return row.contrFornTp_nome
          }
          return null
        },
        size: 100,
        sortingFn: 'alphanumeric',
        Cell: ({ cell, row: contrFornRow }) => {
          if (contrFornRow.original.contrFornTp_nome) {
            return cell.getValue()
          }
          return null
        },
      },
      {
        id: 'acoes',
        header: 'Ações',
        size: 100,
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row: contrFornRow }) => {
          const contrForn = contrFornRow.original
          if (Number(contrForn.contrFornStatus_id) === 1) {
            return (
              <ModalContrFornInfo
                contrFornData={contrForn}
                setListaParcelasDetails={() => {}}
                updateOneEvento={async () => []}
              />
            )
          }
          if (Number(contrForn.contrFornStatus_id) === 11) {
            return (
              <ModalFormContrForn
                contrFornData={contrForn}
                centroDeCustoDisabled
                orcItemDisabled
                pedidoCompraData={{ orcItem_id: contrForn.orcItem_id }}
                loadExistingContrFornOnOpen
                onSuccess={refreshOrcItems}
              />
            )
          }
          if ([8, 2].includes(Number(contrForn.contrFornStatus_id))) {
            return (
              <ModalContrFornInfo
                contrFornData={contrForn}
                setListaParcelasDetails={() => {}}
                updateOneEvento={async () => []}
              />
            )
          }
          return '-'
        },
      },
    ]

    return (
      <div className="p-2">
        <h6 className="mb-3">Contratos</h6>
        <MaterialReactTable
          columns={detailColumns}
          data={contrForns}
          getRowId={(contrForn) => String(contrForn.contrForn_id)}
          localization={MRT_Localization_PT}
          initialState={{
            density: 'compact',
            pagination: { pageIndex: 0, pageSize: 10 },
            columnVisibility: {
              contrForn_num: false,
              contrForn_dtAssin: false,
              contrForn_dtVigIni: false,
              contrForn_dtVigFim: false,
              orcItem_desc: false,
              contrFornTp_nome: false,
            },
          }}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableHiding
          enableGlobalFilter
          enableDensityToggle={false}
          enablePagination={contrForns.length > 10}
          layoutMode="grid"
          muiTopToolbarProps={mrtTopToolbarProps}
          muiTableHeadCellColumnActionsButtonProps={{ size: '8px' }}
          muiTablePaperProps={{ sx: { boxShadow: 'none', border: '1px solid #c5dbe5', backgroundColor: '#fff' } }}
          muiTableBodyCellProps={{ sx: { fontSize: '12px' } }}
          muiTableHeadCellProps={mrtHeadCellProps}
        />
      </div>
    )
  }

  const formatContratoFornDate = (value) => {
    if (!value || value === '0000-00-00') return '-'
    return moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : '-'
  }

  const renderContratoFornField = (label, value) => (
    <div className="col-md-4 mb-2">
      <small className="text-muted d-block">{label}</small>
      <div>{value === null || value === undefined || value === '' ? '-' : value}</div>
    </div>
  )

  const renderContratoFornVinculado = () => {
    const contratoFornId = Number(selectedOrcItemPedidosCompra?.contratoForn_id) || 0
    if (!showEquipePedidoCompraFields || !contratoFornId) return null

    const parteNome = linkedContratoForn?.contratoForn_parteNomePf || linkedContratoForn?.contratoForn_parteNomePj

    return (
      <div className="border rounded p-3 mb-3 bg-light">
        <h6 className="mb-3">Contrato interno vinculado a essa vaga</h6>
        {isLoadingLinkedContratoForn ? (
          <div className="d-flex align-items-center">
            <Spinner size="sm" className="mr-2" />
            <span className="text-muted">Carregando contrato interno...</span>
          </div>
        ) : !linkedContratoForn ? (
          <span className="text-muted">Não foi possível carregar o contrato interno vinculado.</span>
        ) : (
          <>
            <div className="row">
              {renderContratoFornField('Tipo da parte', formatContrFornParteTab(linkedContratoForn.contratoForn_parteTab))}
              {renderContratoFornField('ID da parte', linkedContratoForn.contratoForn_parteId)}
              {renderContratoFornField('Parte vinculada', parteNome)}
              {renderContratoFornField('Descrição', linkedContratoForn.contratoForn_desc)}
              {renderContratoFornField('Valor global', currencyFormatter.format(Number(linkedContratoForn.contratoForn_vlrGlobal || 0)))}
              {renderContratoFornField('Valor do pagamento', currencyFormatter.format(Number(linkedContratoForn.contratoForn_vlrPgto || 0)))}
              {renderContratoFornField('Carga horária mensal', linkedContratoForn.contratoForn_cargaHorariaMes)}
              {renderContratoFornField('Data de início', formatContratoFornDate(linkedContratoForn.contratoForn_ini))}
              {renderContratoFornField('Data de fim', formatContratoFornDate(linkedContratoForn.contratoForn_fim))}
            </div>
            <div className="mt-2">
              <small className="text-muted d-block">Objeto</small>
              <div>{linkedContratoForn.contratoForn_obj || '-'}</div>
            </div>
          </>
        )}
      </div>
    )
  }

  const selectedOrcItemId = getOrcItemId(selectedOrcItemPedidosCompra)
  const selectedOrcItemResp = getOrcItemResp(selectedOrcItemPedidosCompra)
  const selectedPedidosCompra = pedidosCompraByOrcItemId[String(selectedOrcItemId)] || []
  const selectedContratoFornId = Number(selectedOrcItemPedidosCompra?.contratoForn_id) || 0
  const shouldBlockAbrirVaga = showEquipePedidoCompraFields && selectedContratoFornId > 0
  const openCotacaoButtonLabel = 'Abrir cotação'
  const pedidoCotacaoSelOrcItems = orcItems.map((orcItem) => ({
    value: orcItem.orcItem_id,
    label: orcItem.orcItem_desc,
    categGr_id: orcItem.categGr_id,
    nivel2_id: orcItem.nivel2_id,
    projAtuacao_id: orcItem.projAtuacao_id,
    pf_id: orcItem.pf_id,
  }))

  const renderAbrirCotacaoOuVagaButton = () => {
    if (showEquipePedidoCompraFields) {
      return (
        <Button
          size="sm"
          color="link"
          className="mb-2 px-0"
          disabled={shouldBlockAbrirVaga}
          title={shouldBlockAbrirVaga ? 'Esta vaga ja esta preenchida por um contrato interno vinculado ao item orcamentario.' : undefined}
          onClick={() => handleOpenPedidoCompraModal(selectedOrcItemId, selectedOrcItemResp, selectedOrcItemPedidosCompra)}
        >
          Abrir vaga
        </Button>
      )
    }

    return (
      <ButtonDropdown
        isOpen={abrirCotacaoDropdownOpen}
        toggle={() => setAbrirCotacaoDropdownOpen((prev) => !prev)}
      >
        <DropdownToggle
          caret
          size="sm"
          color="link"
          className="mb-2 px-0"
          disabled={shouldBlockAbrirVaga}
          title={shouldBlockAbrirVaga ? 'Esta vaga ja esta preenchida por um contrato interno vinculado ao item orcamentario.' : undefined}
        >
          {openCotacaoButtonLabel}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={() => handleOpenNovoPedidoCotacao(
            TIPO_CONTRATACAO.PADRAO,
            selectedOrcItemId,
            selectedOrcItemResp,
            selectedOrcItemPedidosCompra,
          )}
          >
            {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.PADRAO]}
          </DropdownItem>
          <DropdownItem onClick={() => handleOpenNovoPedidoCotacao(
            TIPO_CONTRATACAO.RAPIDA,
            selectedOrcItemId,
            selectedOrcItemResp,
            selectedOrcItemPedidosCompra,
          )}
          >
            {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.RAPIDA]}
          </DropdownItem>
          <DropdownItem onClick={() => handleOpenNovoPedidoCotacao(
            TIPO_CONTRATACAO.ADESAO,
            selectedOrcItemId,
            selectedOrcItemResp,
            selectedOrcItemPedidosCompra,
          )}
          >
            {TIPO_CONTRATACAO_LABEL[TIPO_CONTRATACAO.ADESAO]}
          </DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    )
  }

  if (!Array.isArray(orcItems)) return null

  return (
    <>
      <MaterialReactTable
        columns={columns}
        data={filteredOrcItems}
        renderTopToolbarCustomActions={() => (
          <>
            <Button
              size="sm"
              color="link"
              className="mb-1 ml-1 px-0"
              onClick={handleOpenModal}
            >
              Adicionar novo
            </Button>
          </>
        )}
        initialState={{
          density: 'compact',
          expanded: {},
          pagination: { pageIndex: 0, pageSize: 500 },
        }}
        filterFns={{
          dateRangeFilterFn: (row, id, filterValue) => {
            if (!filterValue || !filterValue[0] || !filterValue[1]) {
              return true
            }

            return ((row.getValue(id) >= (new Date(filterValue[0])).getTime()) && (row.getValue(id) <= (new Date(filterValue[1])).getTime()))
          },
        }}
        enableFacetedValues
        enableGrouping
        enableGlobalFilter
        enableFilters
        enablePagination
        muiTopToolbarProps={{ sx: {
          '.MuiBox-root': { marginTop: '10px', height: '20px', display: 'flex', alignItems: 'center' },
          '.MuiSvgIcon-root': { width: '12px' },
          '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
          '.MuiTablePagination-root .MuiToolbar-root': { minHeight: '30px !important', height: '30px !important' },
          '.MuiTablePagination-root': { minHeight: '30px !important', height: '30px !important', marginTop: '2.3rem' },
        } }}
        muiTableBodyCellProps={({ column }) => ({
          sx: {
            fontSize: '13px',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            maxWidth: column.id === 'pedidoCompraActions' ? 'none' : '300px',
            overflow: column.id === 'pedidoCompraActions' ? 'visible' : undefined,
          },
        })}
        muiTableBodyRowProps={{
          sx: {
            '& .MuiTableCell-root': {
              // Permite o dropdown de Ações (Equipe) ultrapassar a célula.
              overflow: 'visible',
            },
          },
        }}
        muiTableContainerProps={{
          sx: {
            overflow: 'visible',
          },
        }}
        muiTablePaginationProps={{
          sx: { '.MuiTablePagination-displayedRows': { fontSize: '12px' }, fontSize: '12px' },
          labelRowsPerPage: <span style={{ fontSize: '12px' }}>{labelRowsPerPage}</span>,
          rowsPerPageOptions: [500, 2000],
        }}
        positionPagination="bottom"
        muiTableHeadCellColumnActionsButtonProps={{ size: '8px' }}
        enableDensityToggle={false}
        enableColumnFilters
        muiTableHeadCellProps={{
          sx: {
            fontSize: '12px',
            fontWeight: 'normal',
            padding: '8px',
          },
        }}
        enableRowExpansion
        renderDetailPanel={renderDetailPanel}
      />
      <ModalFormOrcItem
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        onSuccess={refreshOrcItems}
        orcRubrId={orcRubrId}
        categGrId={categGrId}
      />
      <Modal
        isOpen={pedidosCompraListModalIsOpen}
        toggle={handleClosePedidosCompraListModal}
        size="xl"
      >
        <ModalHeader toggle={handleClosePedidosCompraListModal}>{!showEquipePedidoCompraFields ? 'Cotações' : 'Vagas'}</ModalHeader>
        <ModalBody>
          {renderContratoFornVinculado()}
          {isLoadingPedidosCompra || selectedPedidosCompra.length > 0 ? (
            <>
              {!isLoadingPedidosCompra && renderAbrirCotacaoOuVagaButton()}
              {shouldBlockAbrirVaga && (
                <div className="mb-2 text-muted">
                  Esta vaga já está preenchida pelo contrato interno vinculado ao item orçamentário.
                </div>
              )}
              <PedidosCompraListTable
                key={selectedOrcItemId ?? 'empty'}
                pedidosCompra={selectedPedidosCompra}
                showEquipePedidoCompraFields={showEquipePedidoCompraFields}
                onViewPedidoCompra={handleOpenViewPedidoCompraModal}
                onEditPedidoCompra={handleOpenEditPedidoCompraModal}
                onAbrirCotacaoPedidoCompra={handleOpenCotacaoParaPedidoExistente}
                onViewCompraCotacao={handleOpenViewCompraCotacaoModal}
                fetchPedidoCompraDocuments={fetchPedidoCompraDocuments}
                compraCotacoesRefreshKey={compraCotacoesRefreshKey}
                isLoading={isLoadingPedidosCompra}
                onOpenContrForn={handleOpenContrFornFromList}
              />
            </>
          ) : (
            <div className="p-3">
              {renderAbrirCotacaoOuVagaButton()}
              <br />
              <span className="text-muted">
                {shouldBlockAbrirVaga
                  ? 'Esta vaga já está preenchida pelo contrato interno vinculado ao item orçamentário.'
                  : (!showEquipePedidoCompraFields ? 'Nenhuma cotação localizada para este item orçamentário.' : 'Nenhuma vaga localizada para este item orçamentário.')}
              </span>
            </div>
          )}
        </ModalBody>
      </Modal>
      <ModalPedidoCotacao
        isOpen={pedidoCotacaoModalIsOpen}
        onClose={handleClosePedidoCotacaoModal}
        onSuccess={async () => {
          await fetchPedidosCompraByIds(orcItemIds)
          setCompraCotacoesRefreshKey((prev) => prev + 1)
        }}
        user={pedidoCotacaoUser}
        initialPedidoCompraData={pedidoCotacaoInitialData}
        hideCentroDeCusto
        readOnlyOrcItem
        selOrcItemsOptions={pedidoCotacaoSelOrcItems}
        initialTipoContratacao={tipoContratacaoModal}
        lockTipoContratacao
        title={`${openCotacaoButtonLabel} — ${TIPO_CONTRATACAO_LABEL[tipoContratacaoModal] || ''}`.trim()}
        submitLabel={openCotacaoButtonLabel}
      />
      <ModalPedidoCompra
        isOpen={pedidoCompraModalIsOpen}
        onClose={handleClosePedidoCompraModal}
        initialPedidoCompraData={pedidoCompraInitialData}
        editPedidoCompraRow={editPedidoCompraRow}
        showSkipCotacao={false}
        hideCentroDeCusto
        hidePropItem
        hideQuantidadeOportunidades
        readOnlyOrcItem
        selOrcItems={orcItems.map((orcItem) => ({
          value: orcItem.orcItem_id,
          label: orcItem.orcItem_desc,
          categGr_id: orcItem.categGr_id,
          nivel2_id: orcItem.nivel2_id,
          projAtuacao_id: orcItem.projAtuacao_id,
          pf_id: orcItem.pf_id,
        }))}
        hideDtLimite
        title={`Cadastrar ${showEquipePedidoCompraFields ? 'vaga' : 'cotação'}${project?.proj_nome ? ` - Projeto ${project?.proj_nome}` : ''}`}
        submitLabel={showEquipePedidoCompraFields ? 'Adicionar vaga' : 'Adicionar cotação'}
        showEquipePedidoCompraFields={showEquipePedidoCompraFields}
        contratoDtAssin={project?.contrato_dtAssin || null}
        contratoPrazoVigencia={project?.contrato_prazoVigencia || null}
        contratoPrazoVigenciaAditivo={project?.contrato_prazoVigenciaAditivo || null}
        user={{ pf_id: currentPfId }}
        createLinkedTasks={createLinkedTasks}
        onSuccess={async () => {
          await refreshOrcItems()
          await fetchPedidosCompraByIds(orcItemIds)
        }}
        onEquipeSuccess={async (payload) => {
          if (payload?.orcItem_id && payload?.contratoForn_id) {
            updateOrcItemContratoFornInState(payload.orcItem_id, payload.contratoForn_id)
          }
        }}
        initialVagaTipo={
          pedidoCompraInitialData.orcItem_original
            ? 'interno'
            : Number(pedidoCompraInitialData.pedidoCompraStatus_id) === 6
              ? 'externo'
              : ''
        }
      />
      <ModalPedidoCompra
        isOpen={cotacaoPedidoModalIsOpen}
        onClose={handleCloseCotacaoPedidoModal}
        editPedidoCompraRow={cotacaoPedidoExistenteRow}
        showEquipePedidoCompraFields={showEquipePedidoCompraFields}
        showSkipCotacao={false}
        hideCentroDeCusto
        hidePropItem
        hideQuantidadeOportunidades
        hideDtLimite
        modoCotacao
        cotacaoParaPedidoExistente
        title="Adicionar proposta"
        submitLabel="Adicionar proposta"
        user={{ pf_id: currentPfId }}
        onSuccess={async () => {
          await fetchPedidosCompraByIds(orcItemIds)
          setCompraCotacoesRefreshKey((prev) => prev + 1)
        }}
      />
      <ModalPedidoCompra
        isOpen={viewPedidoCompraModalIsOpen}
        onClose={() => {
          setViewPedidoCompraModalIsOpen(false)
          setViewPedidoCompraRow(null)
        }}
        editPedidoCompraRow={viewPedidoCompraRow}
        showSkipCotacao={false}
        hideCentroDeCusto
        //hideOrcItem
        hidePropItem
        hideQuantidadeOportunidades
        hideDtLimite
        readOnly
        selOrcItems={orcItems.map((orcItem) => ({
          value: orcItem.orcItem_id,
          label: orcItem.orcItem_desc,
          categGr_id: orcItem.categGr_id,
          nivel2_id: orcItem.nivel2_id,
          projAtuacao_id: orcItem.projAtuacao_id,
          pf_id: orcItem.pf_id,
        }))}
        title={`Visualizar ${showEquipePedidoCompraFields ? 'vaga' : 'cotação'}${project?.proj_nome ? ` - Projeto ${project?.proj_nome}` : ''}`}
        contratoDtAssin={project?.contrato_dtAssin || null}
        contratoPrazoVigencia={project?.contrato_prazoVigencia || null}
        contratoPrazoVigenciaAditivo={project?.contrato_prazoVigenciaAditivo || null}
        showEquipePedidoCompraFields={showEquipePedidoCompraFields}
        readOnlyOrcItem
        onSuccess={async () => {
          await fetchPedidosCompraByIds(orcItemIds)
        }}
      />
      <ModalPedidoCompra
        isOpen={viewCompraCotacaoModalIsOpen}
        onClose={() => {
          setViewCompraCotacaoModalIsOpen(false)
          setViewCompraCotacaoRow(null)
        }}
        editCompraCotacaoRow={viewCompraCotacaoRow}
        showSkipCotacao={false}
        hideCentroDeCusto
        hidePropItem
        hideQuantidadeOportunidades
        hideDtLimite
        readOnly
        modoCotacao
        title="Visualizar cotação"
      />
    </>
  )
}

export default OrcItemsProj
